import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';
import Vue from 'vue';

import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import SerpTrackingService from '@ve/pages/serp/analytics/yandexAnalytics/serpTrackingService';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import LifeHackBannerView from '@/js/common/components/lifeHackBanner/LifeHackBanner';
import checkLotteryService from '@/js/common/Domain/Service/checkLottery';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import LotteryBannerView from '@/js/desktop/components/search/lotteryBannerSerp/LotteryBanner';
import TourHunterSubscribeView from '@/js/desktop/components/search/tourHunterSubscribe/TourHunterSubscribe';
import ThFavoritesView from '@/js/desktop/components/thFavorites/thFavorites';
import { productTypes } from '@fr/constants';
import { createAnchorObserver } from '@shared/lib';

import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';
import '@/css/desktop/tooltip.scss';

import componentsBannerTemplate
    from '@view/desktop/travelata/layout/parts/search/search__tour-usually-includes-js.phtml';
import hotelGiftCertificatesBannerTemplate
    from '@view/desktop/travelata/layout/parts/search/search__hotel-gift-certificates-js.phtml';

import '@/js/desktop/components/search/useFilters/styles/useFilters.css';

import appBannerTemplate from '@/js/desktop/components/search/appBanner';
import genleadBannerTemplate from '@view/desktop/travelata/layout/parts/search/search__regions-msg.phtml';

import CashbackPartialPaymentTourBannerView
    from '@/js/desktop/components/partialPayment/cashbackPartialPaymentTourBanner/cashbackPartialPaymentTourBanner';
import PartialPaymentTourBannerView
    from '@/js/desktop/components/partialPayment/partialPaymentTourBanner/partialPaymentTourBanner';

import paylateBnr from '@/js/desktop/components/search/paylate/paylateBnr/paylateBnr';
import { getDesktopTourHotBannerSlots, getDesktopTourSearchBannerSlots } from '@shared/lib/serpBanners';

import checkTourCashbackAvailable from '@/js/common/Domain/Service/checkTourCashbackAvailable';
import SearchPageHotelCardAbstract from '@/js/desktop/View/Abstract/SearchPageHotelCardAbstract';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';
import preparePropsForHotelCardRightBlock from '@ve/components/serpHotelCard/services/preparePropsForHotelCardRightBlock';
import { getToursConfirmationType, getTourConfirmationType } from '@entities/tourProduct';
import { ConfirmationTypeIcon, isConfirmationTypeVisible } from '@entities/confirmationType';
import promoA51BannerTemplate
    from '@view/desktop/travelata/layout/parts/search/search__hotel-a51-js.phtml';
import PromoPlacementManager from '@/js/desktop/services/PromoPlacementManager';
import hotelTemplate from './searchPageHotel/hotelTemplate.html';
import initGiftCertificatesBanner from '@ve/components/banners/giftCertificates/initGiftCertificatesBanner';

let a51ElRef = null;

const SearchPageHotelViewModel = Backbone.Epoxy.Model.extend({
    defaults: {
        hotelIndex: null,
        getBannerAt: null,
        leadBannerAt: null,
        regionType: null,
        regionWithOffices: null,
        searchPageModel: null,
        subscribeBannerView: null,
        subscribeBanner: null,
        lifeHackBannerEmailWasSend: false,
        hidePartialBanner: false,
        subscribeActivatePopularityOffersFilters: false,
    },
    computeds: {
        lotteryBanner: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                if (getBannerAt(hotelIndex + 1) !== 'dreamTour') return '';
                return (new LotteryBannerView()).$el;
            },
        },
        genleadBanner: {
            deps: ['hotelIndex', 'getBannerAt', 'regionType', 'regionWithOffices'],
            get(hotelIndex, getBannerAt, regionType, regionWithOffices) {
                const isCatchPriceSlot = getBannerAt(hotelIndex + 1) === 'catchPrice';
                return (isCatchPriceSlot && regionType === 'region' && regionWithOffices && document.location.pathname !== '/search') ? genleadBannerTemplate() : '';
            },
        },
        componentsBanner: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                const bannerId = getBannerAt(hotelIndex + 1);
                if (bannerId === 'tourIncludes') return componentsBannerTemplate({ hotelIndex });
                if (bannerId === 'gift') return hotelGiftCertificatesBannerTemplate({ hotelIndex });
                return '';
            },
        },
        appBanner: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                return getBannerAt(hotelIndex + 1) === 'appPromo' ? appBannerTemplate() : '';
            },
        },
        lifeHackBanner: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                if (getBannerAt(hotelIndex + 1) !== 'hacks8') return '';
                return (new LifeHackBannerView({ model: this })).$el;
            },
        },
        leadBanner: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                return getBannerAt(hotelIndex + 1) === 'assistantSales'
                    ? `<div class="card-lead-banner" data-card-index="${hotelIndex}"></div>`
                    : '';
            },
        },
        paylateBnr: {
            deps: ['hotelIndex', 'getBannerAt'],
            get(hotelIndex, getBannerAt) {
                if (getBannerAt(hotelIndex + 1) !== 'buyNow') return '';
                return paylateBnr(hotelIndex);
            },
        },
        promoA51Banner: {
            deps: ['hotelIndex'],
            get(hotelIndex) {
                if (hotelIndex !== 3) return '';
                if (a51ElRef) {
                    return $(a51ElRef);
                }
                const tmpDiv = document.createElement('div');
                tmpDiv.innerHTML = promoA51BannerTemplate();
                a51ElRef = tmpDiv.firstChild;
                return $(a51ElRef);
            },
        },
        conditionalBanner: {
            deps: ['subscribeBanner', 'genleadBanner'],
            get: (subscribeBanner, genleadBanner) => (subscribeBanner && !genleadBanner ? subscribeBanner : genleadBanner),
        },
        visibleBanners: {
            deps: ['subscribeActivatePopularityOffersFilters'],
            get: (subscribeActivatePopularityOffersFilters) => !subscribeActivatePopularityOffersFilters,
        },
    },
    calculateSybscribeBanner() {
        let $subscribeBanner = '';
        let subscribeBannerView;
        const hotelIndex = this.get('hotelIndex');
        const getBannerAt = this.get('getBannerAt');
        const searchPageModel = this.get('searchPageModel');

        if (getBannerAt(hotelIndex + 1) === 'catchPrice') {
            subscribeBannerView = new TourHunterSubscribeView({
                trackingService: new SerpTrackingService(),
                searchPageModel,
                searchFormViewModel: this.searchFormViewModel,
                hotelIndex,
            });
            $subscribeBanner = this.subscribeBannerTemplate || subscribeBannerView.$el;
        }

        this.set('subscribeBannerView', subscribeBannerView);
        this.set('subscribeBanner', $subscribeBanner);
    },
    initModelEvents() {
        this.on('change:getBannerAt', $.proxy(this.calculateSybscribeBanner, this));
    },
    initialize(options) {
        this.searchFormViewModel = options.searchFormViewModel;
        this.subscribeBannerTemplate = options.subscribeBannerTemplate;
        this.initModelEvents();
    },
});

@extendDecorator({
    el: '<div class="serpHotelCard"></div>',
    hotelTemplate,
    data: null,
    template: null,
    searchFormViewModel: null,
    bindings: {
        '.serpHotelCard': 'classes:{isExclusive: isExclusive}',
        '.js-componentsBanner': 'html: componentsBanner',
        '.js-lotteryBanner': 'html: lotteryBanner',
        '.js-conditionalBanner': 'html: conditionalBanner',
        '.js-appBanner': 'html: appBanner',
        '.js-lifeHackBanner': 'html: lifeHackBanner',
        '.js-card-lead-banner': 'html: leadBanner',
        '.js-paylateBnr': 'html: paylateBnr',
        '.js-promoA51Banner': 'html: promoA51Banner',
        '.js-visible-banners-hotel-card': 'toggle: visibleBanners',
    },
    events: {
        'click .serpHotelCard__container': 'setInCookieMinPrice',
        'click .goToHotel': 'goToHotel',
        'click .js-images-carousel-control-prev': 'sliderArrowClick',
        'click .js-images-carousel-control-next': 'sliderArrowClick',
        'click .serpHotelCard__container a:not(.goto-ua-page, .notChange, .cashbackPartialPaymentTourBanner-cashbackSection__link)': 'callYMGoals',
        'mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange, .cashbackPartialPaymentTourBanner-cashbackSection__link)': 'hotelClick',
        'click .regionsMsg__btn span': 'openGeneralLead',
        'click .thSubscribeBtn': 'submitTourHunter',
        'click .js-th-button': 'submitTourHunter',
        'submit .js-th-form': 'submitTourHunter',
        'click .banner-close': 'closeBanner',
    },
})
export default class SearchPageHotelView extends SearchPageHotelCardAbstract {
    closeBanner(e) {
        const { currentTarget } = e;
        const banerName = $(currentTarget).data('banner');
        const bannerPosition = $(currentTarget).data('index') + 1;
        const parent = currentTarget.parentElement;

        if (!parent) return;

        window.dataLayer.push({
            event: 'selectContent',
            selectContent:
                {
                    prop: [
                        { type: 'engageBanner', value: banerName },
                    ],
                    prop2: [
                        { type: 'position', value: bannerPosition },
                    ],
                },
        });

        $(parent).remove();
    }

    isGroupSearch() {
        const grouppedRooms = this.model?.get('tourProducts')?.map((t) => t?.get('tour')?.get('roomGroups'));
        const isGroupSearch = grouppedRooms?.some((rooms) => rooms?.length > 1);
        return isGroupSearch;
    }

    trackingHotelClick() {
        if(!this.isGroupSearch()) {
            trackingService.trackSerpHotelPosition({
                hotels: this.collectionView.collection,
                selectedHotel: this.model,
                sortStrategy: this.collectionView.model.get('sortStrategy'),
            });
        }
    }

    mindBoxTrackingHotelClick() {
        if(!this.isGroupSearch()) {
            mindBoxService.trackViewSerpClick('serp_main', {
                searhPageModel: this.model,
                collectionViewModel: this.collectionView.model,
            });
        }
    }

    hotelClick(e) {
        this.trackingHotelClick();
        this.mindBoxTrackingHotelClick();
        this.dataLayerEvents();
        this.hrefUrl(e);
    }

    async openGeneralLead() {
        const tourCriteria = this.collectionView.model.get('searchData');

        const { default: generalLead } = await import(/* webpackChunkName: "general-lead" */ '@/js/desktop/components/generalLead/general-lead.js');

        generalLead.open(tourCriteria ? {
            tourCriteria,
        } : {});
    }

    setInCookieMinPrice() {
        $.cookie('hotelMinPrice', this.model.get('priceWithOilTax'), {
            expires: 1 / 24 / 60 / 3,
            path: '/',
            domain: 'all',
        });
    }

    isHotView() {
        return false;
    }

    _buildGetBannerAt() {
        const getter = this.isHotView() ? getDesktopTourHotBannerSlots : getDesktopTourSearchBannerSlots;
        const enableLottery = checkLotteryService();
        const tourhunterAlreadySubscribed = this.collectionView.model.get('tourhunterAlreadySubscribed');
        const isLeadBannerCardActive = this?.collectionView?.model?.get('activeLeadBannerType') === 'card';
        const promoMgr = PromoPlacementManager.getInstance();
        const hasA51 = promoMgr.promoPlacements.some((p) =>
            Number(p.countryId) === Number(promoMgr.currentCountryId) &&
            promoMgr.getPlacementType(p.placementId) === 'a51'
        );
        const hasCashback = !!window?.appConfig?.cashbackAvailable;
        const isEnabled = (id) => {
            if (id === 'assistantSales') return isLeadBannerCardActive;
            if (id === 'dreamTour') return enableLottery;
            if (id === 'subscribe') return !tourhunterAlreadySubscribed;
            if (id === 'adfox') return false;
            if (id === 'a51') return hasA51;
            if (id === 'cashback') return hasCashback;
            return true;
        };
        const totalCards = this.collectionView.collection.length;
        const slots = getter({ totalCards, isEnabled });
        return (cardIndex) => slots.find((s) => s.cardIndex === cardIndex)?.bannerId ?? null;
    }

    _buildLeadBannerAt() {
        const isLeadBannerCardActive = this?.collectionView?.model?.get('activeLeadBannerType') === 'card';
        if (!isLeadBannerCardActive) return null;

        const promoMgr = PromoPlacementManager.getInstance();
        const hasA51 = promoMgr.promoPlacements.some((p) =>
            Number(p.countryId) === Number(promoMgr.currentCountryId) &&
            promoMgr.getPlacementType(p.placementId) === 'a51'
        );
        const hasCashback = !!window?.appConfig?.cashbackAvailable;

        const targetCardIndex = hasA51 ? 7 : hasCashback ? 5 : 3;
        const totalCards = this.collectionView.collection.length;

        return totalCards >= targetCardIndex ? targetCardIndex : null;
    }

    render() {
        let template;
        const data = this.model.toJSON({ computed: true });
        const hotelIndex = this.collectionView.collection.indexOf(this.model);

        if (this.collectionView) {
            template = this.selectTemplate();
        }

        data.originalHotelObject = this.model;

        this.viewModel = new SearchPageHotelViewModel({
            hotelIndex,
            getBannerAt: this._buildGetBannerAt(),
            leadBannerAt: this._buildLeadBannerAt(),
            regionType: this.collectionView.model.get('regionType'),
            regionWithOffices: this.collectionView.model.get('regionWithOffices'),
            searchPageModel: this.collectionView.model,
            searchFormViewModel: this.searchFormViewModel,
            subscribeBannerTemplate: this.subscribeBannerTemplate || null,
            subscribeActivatePopularityOffersFilters: this.collectionView?.filters?.model.get('isPopularityFilterActive'),
        });
        data.hotelIndex = hotelIndex;

        if (hotelIndex === 3 && a51ElRef && a51ElRef.parentNode) {
            a51ElRef.parentNode.removeChild(a51ElRef);
        }

        if (this.hotelMapView) {
            this.hotelMapView.reRender({
                data,
                $el: this.$el,
                parentModel: this.model,
                collectionView: this.collectionView,
            });
        } else {
            this.$el.html(template(data));
        }

        initGiftCertificatesBanner();

        setTimeout(() => {
            this.applyBindings();
            this.viewModel.calculateSybscribeBanner();

            this.leadBannerAnchor = createAnchorObserver('lead-banner', '.card-lead-banner', this);

            if (hotelIndex === 3) {
                PromoPlacementManager.getInstance().createA51Placement();
            }
        }, 0);

        this.data = data;

        this.initCarousel();
        this.renderPhotos();
        this.initSubViews();
        this.initVueComponents();
        this.initConfirmation();
        this.showBottomBanner();
    }

    getPropsForHotelCardRightBlock() {
        const tourProduct = this.model.get('tourProducts').at(0);
        const tour = tourProduct.get('tour');

        return preparePropsForHotelCardRightBlock({
            product: tour,
            productPrice: tour.get('priceWithOilTax'),
            productType: productTypes.TOUR_OFFER,
            touristText: tourProduct.get('touristText'),
        });
    }

    showBottomBanner() {
        const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();
        const hasTourCashbackAvailable = checkTourCashbackAvailable(this.model.get('tourProducts'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }

            this.initCashbackBanner('tour');
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    }

    getPartialPaymentData() {
        if (!this.model) {
            return {
                isVisible: false,
                countryName: '',
                tourProducts: null
            };
        }

        const tourProducts = this.model.get('tourProducts');
        if (!tourProducts) {
            return {
                isVisible: false,
                countryName: '',
                tourProducts: null
            };
        }

        const tourProduct = tourProducts.at(0);
        const country = this.model.get('country');
        const isSelectedPrepayments = !!this?.collectionView?.model?.get('filterCriteria')?.get('prepayments')?.length;
        const isVisible = !!tourProduct?.get('firstPaymentDefinition')?.id && !isSelectedPrepayments;
        const countryName = country?.get?.('name') || '';


        return {
            isVisible,
            countryName,
            tourProducts,
        };
    }

    initConfirmation() {
        const tourProducts = this.model.get('tourProducts')?.models.map((tourProduct) => tourProduct.get('tour').attributes) || [];
        const types = tourProducts.map((t) => getTourConfirmationType(t));
        if(isConfirmationTypeVisible(types)) {
            new Vue({
                render: (h) => h(ConfirmationTypeIcon, {
                    props: {
                        type: this.getToursConfirmationType(),
                    },
                }),
            }).$mount(this.el.querySelector('.js-confirmation-icon'));
        }

    }

    initPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        new PartialPaymentTourBannerView({
            el: this.$el.find('.partialPayment__banner'),
            countryName,
            tourProducts,
        });
    }

    initCashbackPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        new CashbackPartialPaymentTourBannerView({
            el: this.$el.find('.cashbackPartialPayment__banner'),
            countryName,
            tourProducts,
        });
    }

    initSubViews() {
        new ThFavoritesView({
            model: this.model,
            searchPageModel: this.collectionView.model,
            el: $('.addToFavorites', this.$el),
        });

        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    }

    initSubscribes() {
        this.model.on('change:minPrice', $.proxy(this.reRender, this));
        this.model.on('change:tourProducts', $.proxy(this.reRender, this));



        checkLotteryService(() => {
            this.viewModel.set('getBannerAt', this._buildGetBannerAt());
        });

        if (this.collectionView) {
            this.collectionView.model.on('change:activeLeadBannerType', () => {
                this.viewModel.set('leadBannerAt', this._buildLeadBannerAt());
                this.viewModel.set('getBannerAt', this._buildGetBannerAt());
                this.leadBannerAnchor?.observe(this.el);
            });
            this.collectionView.model.on('change:tourhunterAlreadySubscribed', this.updateSubscribes.bind(this));
            this.collectionView.model.on('change:regionType', (model, value) => {
                this.viewModel.set('regionType', value);
            });
            this.collectionView.model.on('change:regionWithOffices', (model, value) => {
                this.viewModel.set('regionWithOffices', value);
            });

            if (this.collectionView.collection) {
                this.listenTo(this.collectionView.collection, 'add remove reset update', () => {
                    this.viewModel.set('leadBannerAt', this._buildLeadBannerAt());
                    this.viewModel.set('getBannerAt', this._buildGetBannerAt());
                });
            }
        }
    }

    updateSubscribes() {
        const subscribeBannerView = this.viewModel.get('subscribeBannerView');
        const $tourhunterBlock = this.viewModel.get('subscribeBanner');

        if (!$tourhunterBlock || !subscribeBannerView || !subscribeBannerView.currentSubscribeBanner()) {
            this.viewModel.set('getBannerAt', this._buildGetBannerAt());
        }
    }

    getComponentsData() {
        checkLotteryService(() => {
            this.viewModel.set('getBannerAt', this._buildGetBannerAt());
        });
    }

    initialize(options) {
        this.serpTrackingService = new SerpTrackingService();
        this.collectionView = options.collectionView;
        this.dataLayerAnalytics = options.collectionView.dataLayerAnalytics;
        this.template = options.template ? options.template : this.hotelTemplate;
        this.hotelMapView = options.hotelMapView;
        this.model.$element = this.$el;

        this.render();
        this.initSubscribes();
        this.getComponentsData();
    }

    getToursConfirmationType() {
        const tourProducts = this.model.get('tourProducts')?.models.map((tourProduct) => tourProduct.get('tour').attributes);
        const confirmationType = getToursConfirmationType(tourProducts || []);

        return confirmationType;
    }

    trackClickConfirmationTours() {
        this.serpTrackingService.clickTourButtonWithConfirmation(this.getToursConfirmationType());
    }

    hrefUrl(event) {
        this.trackClickConfirmationTours();
        const tourProduct = this.model.get('tourProducts').at(0);
        const identity = tourProduct.get('id');
        const urlParams = this.buildUrlParams();
        const hotelUrl = this.model.get('url');
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const $target = $(event.currentTarget);

        if (typeof identity !== 'undefined') {
            if (event.which === 2) {
                gaAsync(() => {
                    ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', { nonInteraction: 1 });
                });
            }
        } else if (event.which === 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
            gaAsync(() => {
                ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', { nonInteraction: 1 });
            });
        }
        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
        $(event.currentTarget).attr('target', target);
        ls.set('isAbsent', false);
    }

    buildUrlParams() {
        const tourProduct = this.model.get('tourProducts').at(0);
        const urlParams = {
            tourCriteria: tourProduct.get('tourCriteria'),
            productType: productTypes.TOUR_OFFER,
            similar: !!this.model.get('similar'),
            isExclusive: this.collectionView.model.get('filterCriteria').get('isExclusive'),
            identity: tourProduct.get('id'),
            minPrice: this.model.get('priceWithOilTax'),
            prepayments: this.getPrepayments(),
            oilTaxPrice: tourProduct.get('tour').get('oilTax') || (tourProduct.get('tour').get('oilTax') === 0 ? '0' : null),
            operatorId: tourProduct.get('tour').get('operator').id,
            sid: searchSessionService.getSearchId(),
            suuid: trackingService.getSearchUuid(),
            bonusMiles: this.collectionView.model.get('filterCriteria').get('bonusMiles'),
            mirCashback: this.collectionView.model.get('filterCriteria').get('mirCashback'),
        };
        const result = toRouterHotelHydrator(urlParams);

        return result;
    }

    offerClick() {
        ecommerceService.productClick({
            product: this.model,
            category: 'tour',
            pageType: 'serpTour',
            collection: this.collectionView.collection,
            departureCityName: this.collectionView.model.get('searchData').get('departureCity').get('name'),
        });
    }

    dataLayerEvents() {
        if (!this.dataLayerAnalytics) {
            return;
        }
        this.dataLayerAnalytics.searchClickEvent(this);
    }

    isHotelHotView() {
        return false;
    }
}
